export default __webpack_public_path__ + "static/media/onions.4eb81608.jpg";